module.exports = __webpack_public_path__ + "media/banners/bnr_kiso-2550037b.png";